<template>
  <div
    v-if="isAgent"
    class="agent-wrap"
  >
    <div class="agent-header">
      <div class="headline">
        {{ $t('mediator.mediatorData') }}
      </div>
      <div class="btn-container">
        <button
          class="reset-request-btn"
          @click="resetRequest()"
        />
        <button
          class="remove-agent-btn"
          @click="removeAgentAuth()"
        >
          &times;
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-24 col-md-12 col-xs-12">
        {{ $t('mediator.mediatorName') }}:
      </div>
      <div class="col-24 col-md-12 col-xs-12">
        {{ formatedHeadline }}
      </div>
    </div>
    <div class="row">
      <div class="col-24 col-md-12 col-xs-12">
        {{ $t('mediator.mediatorID') }}:
      </div>
      <div class="col-24 col-md-12 col-xs-12">
        {{ agent.details.id }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentDetails',
  data() {
    return {
      agent: this.$store.state.agent,
    }
  },
  computed: {
    isAgent() {
      return this.$store.state.agent.isAgent === true
    },
    isCompany() {
      return this.agent.details.company !== ''
    },
    formattedSalutation() {
      const { gender } = this.agent.details
      if (['Company', 'female', 'male'].indexOf(gender) >= 0) {
        const salutation = gender.charAt(0).toUpperCase() + gender.slice(1)
        return `${this.$t(`basics.gender${salutation}`)} `
      }
      return ''
    },
    formatedHeadline() {
      const { details } = this.agent
      const title = `${details.title} ` || ''
      const salutation = this.formattedSalutation
      const agentName = `${salutation}${title}${details.firstName} ${details.lastName}`
      return this.isCompany ? details.company : agentName
    },
  },
  methods: {
    removeAgentAuth() {
      const result = confirm(this.$t('mediator.endSessionWarning')) // eslint-disable-line
      if (result) {
        this.$store.commit('RESET_AGENT')
        this.$store.commit('resetNewContractState')
        this.$store.commit('RESET_AUTHENTICATION')
        this.$router.push(this.localizedRoute('InsuranceRequestStart'))
      }
    },
    resetRequest() {
      const currentToken = this.$store.state.agent.token
      const result = confirm(this.$t('mediator.refreshWarning')) // eslint-disable-line
      if (result) {
        this.$store.commit('resetNewContractState')
        this.$store.commit('RESET_AUTHENTICATION')
        if (this.$route.name.indexOf('AgentRequestStart') === 0) {
          // Reload page
          this.$router.go()
        } else {
          this.$router.push(this.localizedRoute('AgentRequestStart', { query: { token: currentToken } }))
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "styles/index";
</style>
